module.exports = __webpack_public_path__ + "img/ribbon-gold.c18dd162.svg";